import styled from "styled-components";
import { LOGO_HOME } from "@assets";
import { SyncOutlined } from "@ant-design/icons";

export const Bar = styled.div`
  height: 70px;
  padding-inline: 16px;
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  background: ${(props) => props.theme.appbarColor};
  z-index: 1000;
`;

export const LogoWrapper = styled.div`
  flex: 1;
  display: flex;
  gap: 5px;
  align-items: flex-end;
  justify-content: flex-start;
`;

export const Logo = styled(LOGO_HOME)``;

export const IconsWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;

  svg {
    cursor: pointer;
  }

  @media screen and (max-width: 320px) {
    gap: 6px;

    svg {
      width: 20px;
    }
  }
`;

export const Icon = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 12px;
  background: linear-gradient(180deg, #181103 0%, #744800 100%);
  cursor: pointer;

  @media screen and (max-width: 320px) {
    padding: 3px 6px;
  }
`;

export const Text = styled.div`
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 100;
  line-height: 1.5;

  @media screen and (max-width: 320px) {
    font-size: 13px;
  }
`;

export const Wallet = styled.div`
  display: flex;
  align-items: center;
  background: linear-gradient(180deg, #181103 0%, #744800 100%);
  border-radius: 12px;
`;

export const WalletTop = styled.div`
  padding-left: 5px;
  padding-right: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const WalletText = styled.div`
  font-weight: 400;
  font-size: 13px;
  color: #FFFFFF;
  padding-right: 5px;
  min-width: 50px;

  @media screen and (max-width: 350px) {
    font-size: 10px;
  }
`;

export const WalletTopAdd = styled.div`
  border-radius: 0px 12px 12px 0px;
  background: linear-gradient(180deg, #FE8A02 0%, #FFEC63 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
`;

export const ReloadIcon = styled(SyncOutlined)`

`;